require("./sitio");
require("bootstrap");


$("#tarjeta-slide .slide-opciones").slick({
    autoplay: true,
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
});

$("#espacios .slide-espacios").slick({
    autoplay: true,
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow:
        '<a href="javascript:void(null);" id="arrow-left-espacios" class="arrow arrow-left"><img src="/images/mejora-tu-casa/flecha_boton.svg"/></a>',
    nextArrow:
        '<a href="javascript:void(null);" class="arrow arrow-right"><img src="/images/mejora-tu-casa/flecha_boton.svg"/></a>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

$(document).ready(function () {
    if ($("#modal-promociones").length) {
        $("#modal-promociones").modal("show");

        $("#cerrar-modal-promocion").click(function () {
            $("#modal-promociones").modal("hide");
        });
    }

    $("#hero .slides").slick({
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
    // Luego, una vez que las flechas estén disponibles en el DOM, puedes cambiar su visibilidad según sea necesario.
    $('#hero .prev-btn').click(function() {
        $("#hero .slides").slick('slickPrev');
    });

    $('#hero .next-btn').click(function() {
        $("#hero .slides").slick('slickNext');
    });
});

